class SubscribeAndSave {
    constructor(containerSelector) {
        this.containerSelector = containerSelector;
        this.selectedSellingPlanId = null; // Add a property to store the selected selling plan ID
        this.finalizeCheckoutTriggered = false;
        this.init();
        this.observeContainer();
    }

    init() {
        this.container = document.querySelector(this.containerSelector);

        if (!this.container) {
            console.error('Container not found');
            return;
        }

        this.subscribeButton = this.container.querySelector('a[href="#subscribe"]');
        this.subscriptionSelection = this.container.querySelector('.subscription-selection');
        this.labels = this.container.querySelectorAll('.input-selection');
        this.finalizeCheckoutButton = this.container.querySelector('a[href="#continue_to_checkout"]');
        this.appstleId = this.container.dataset.appstleId;
        this.appstleName = this.container.dataset.appstleName;

        if (!this.subscribeButton || !this.subscriptionSelection || !this.labels || !this.finalizeCheckoutButton) {
            console.error('Required elements not found');
            return;
        }

        this.productHandlers = JSON.parse(document.getElementById('product-handlers').textContent);
        this.addEventListeners();
    }

    observeContainer() {
        const observer = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        if (node.matches && node.matches(this.containerSelector)) {
                            this.init();
                        }
                    });
                }
            }
        });

        const parentElement = document.querySelector('body'); // Adjust this to the appropriate parent element
        const config = { childList: true, subtree: true };
        observer.observe(parentElement, config);
    }

    addEventListeners() {
        this.subscribeButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.showSubscriptionSelection();
        });

        this.labels.forEach((label, index) => {
            if(index == 0){
              this.activateInput(label);
            }
            label.addEventListener('click', (event) => {
                this.activateInput(label);
            });
        });

        this.finalizeCheckoutButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.processCheckout();
        });
    }

    showSubscriptionSelection() {
        if(this.subscribeButton.classList.contains('open')){
          this.subscribeButton.classList.remove('open');
          this.subscriptionSelection.style.display = 'none';
          document.querySelector(".cart__ctas").style.display = 'block';
        }else{
          this.subscribeButton.classList.add('open');
          this.subscriptionSelection.style.display = 'block';  
          document.querySelector(".cart__ctas").style.display = 'none';
        }
        
    }

    activateInput(label) {
        const input = label.querySelector('input[type="radio"]');
        if (input) {
            input.checked = true;
            this.selectedSellingPlanId = input.value; // Store the selected selling plan ID
        }
    }

    async processCheckout() {

      if (this.finalizeCheckoutTriggered) {
          return;
      }
      this.finalizeCheckoutTriggered = true;

      
        try {
            this.finalizeCheckoutButton.disabled = true;
            const cartData = await this.fetchCartData();
            const totalQuantity = cartData.items.reduce((sum, item) => sum + item.quantity, 0);
            const matchedHandler = this.productHandlers.find(handler => handler.product_count == totalQuantity);

            if (matchedHandler) {
                const variantId = matchedHandler.variant_id;
                const productNames = cartData.items.map(item => `${item.quantity}x ${item.product_title.replace(/,/g, '-')}`).join(', ');
                const skus = cartData.items.map(item => item.sku).join(', ');
                const variants = cartData.items.map(item => `${item.variant_id}:${item.quantity}`).join(', ');

                console.log(productNames);
                console.log(skus);
                console.log(variants);

                await this.clearCart();
                await this.addToCart(variantId, productNames, skus, variants, this.selectedSellingPlanId);
                window.location.href = '/checkout';
            } else {
                console.error('No matching product handler found for total quantity:', totalQuantity);
            }
        } catch (error) {
            console.error('Error processing checkout:', error);
        } finally {
            this.finalizeCheckoutButton.disabled = false;
        }
    }

    async fetchCartData() {
        const response = await fetch('/cart.js');
        if (!response.ok) {
            throw new Error('Failed to fetch cart data');
        }
        return await response.json();
    }

    async clearCart() {
        const response = await fetch('/cart/clear.js', { method: 'POST' });
        if (!response.ok) {
            throw new Error('Failed to clear cart');
        }
        return await response.json();
    }

    async addToCart(variantId, productNames, skus, variants, sellingPlanId) {
        const data = {
            items: [
                {
                    id: variantId,
                    quantity: 1,
                    selling_plan: sellingPlanId,
                    properties: {
                        'products': productNames,
                        '_appstle-bb-id': this.appstleId,
                        '__appstle-bb-name': this.appstleName,
                        '_appstle-bb-product-sku': skus,
                        '__appstle-bb-variants': variants
                    }
                }
            ]
        };

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error('Failed to add to cart');
        }
        return await response.json();
    }
}

// Instantiate the class
new SubscribeAndSave('.subscribe-and-save');
